import { FadeUp } from "@/components/site/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Sourcing without compromise",
    body: "We maintain deep relationships with certified mills across five continents, securing consistent quality and stable pricing even in volatile markets.",
  },
  {
    n: "02",
    title: "Trading built on trust",
    body: "Every contract is backed by decades of combined market expertise. We hedge volatility so our partners can plan with confidence.",
  },
  {
    n: "03",
    title: "Cut to your spec",
    body: "In-house quick sheet-cutting centres in Bhiwandi and Ahmedabad deliver made-to-size sheets with just-in-time reliability across India.",
  },
];

export const Manifesto = () => {
  return (
    <section id="about" data-testid="manifesto-section" className="bg-background py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <FadeUp>
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-primary mb-6">/ Who we are</p>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.95] max-w-4xl text-balance">
            A materials partner engineered for the modern packaging economy.
          </h2>
        </FadeUp>

        <div className="mt-20 md:mt-28 grid md:grid-cols-3 gap-x-10 gap-y-16">
          {CHAPTERS.map((c, i) => (
            <FadeUp key={c.n} delay={i * 0.1}>
              <div className="border-t border-foreground pt-6">
                <span className="font-mono2 text-6xl md:text-7xl text-primary/90 block leading-none">{c.n}</span>
                <h3 className="font-display text-2xl md:text-3xl mt-6 mb-4">{c.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{c.body}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
